module.exports = __webpack_public_path__ + "img/example-sports-results.4f8f0268.webp";